<template>
<!-- loading组件 -->
    <div id="loading">
        <span class="icon iconfont icon-jiazai rotateInfinit"></span>
    </div>
</template>
<script>
export default {
    data() {return {}}
}
</script>
<style lang="less" scoped>
#loading {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    z-index: 99999;
    .icon {
        font-size: 40px;
        color: #cacaca;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, 50%)
    }
}
</style>
<style>
/* //loading的无限旋转 */
@keyframes rotateInfinit {
    from {
        transform: rotate(0)
    }
    to {
        transform: rotate(360deg)
    }
}
  .rotateInfinit {
    -webkit-animation: rotateInfinit 2s infinite ease-in-out;
    animation:rotateInfinit 2s infinite ease-in-out ;
  }

</style>

